import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '432px',
      height: '204px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    titleContainer: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.085)',
    },

    title: {
      marginLeft: '16px',
      marginTop: '16px',
      order: 0,
    },

    textContainer: {
      margin: '16px',
      order: 1,
    },

    buttons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignUItems: 'flex-start',
      margin: '0',
      padding: '16px',
      gap: '16px',
      order: 2,
    },
  },
  {
    name: 'ErrorModal',
  },
);
